export const clients = {
	headerChart: {
		total: "Total de clientes",
		label: "durante el período",
		averagePublic: "Público promedio",
		filters: {
			label: "Filtros",
			men: "Hombres",
			women: "Mujeres",
			others: "Otros",
		},
	},
	averagePublicPerWeekDay: {
		title: "Público promedio por día de la semana",
		label: "Valor promedio de público por día de la semana durante el período",
		averageTicket: "Ticket Promedio",
	},
	clientRecordPerDay: {
		title: "Récord de público",
		label: "Mayores cantidades de público durante el período",
		none: "Nadie",
		person: "{{num}} persona",
		people: "{{num}} personas",
	},
	topClients: {
		title: "TOP Clientes",
		label: "Valor durante el período",
		infoLabel: "Seleccione un cliente para ver detalles.",
	},
	topTables: {
		title: "TOP Mesas",
		label: "Valor durante el período",
		infoLabel: "Seleccione una mesa para ver detalles.",
	},
};
